import Layout4Main from "components/layout/Layout4Admin";
import { Row, Col, Form, Button, Tab, Table, Breadcrumb } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Css from './Customer.module.css';
import ApiConection from "api_ref/ApiConection";
import { useEffect, useState } from "react";
import { AddCommar, ConvertDateTimeToText, DisplayPaging } from "components/MyControl";
import Layout4Admin1 from "components/layout/Layout4Admin1";
import Footer4Bottom1 from "components/layout/Foot4Bottom1";
import ProfileCompany from "./ProfileCompany";
import ProfileUser from "./ProfileUser";
import ProfilePayee from "./ProfilePayee";
import ProfilePackage from "./ProfilePackage";
import ProfilePackageHistory from "./ProfilePackageHistory";
import ProfileUseage from "./ProfileUseage";
import CustomerActions from "./customer-management/components/CustomerActions";

const arr_table = [
    { seq: 1, date: '2022-01-15', package: 'Standard', payment_method: 'โอนเงิน', amount: 'Baht 990.00', transaction_no: 'T000000000' },
    { seq: 2, date: '2021-12-15', package: 'Standard', payment_method: 'โอนเงิน', amount: 'Baht 990.00', transaction_no: 'T000000000' },
    { seq: 3, date: '2021-11-15', package: 'Standard', payment_method: 'โอนเงิน', amount: 'Baht 990.00', transaction_no: 'T000000000' },
    { seq: 4, date: '2021-10-15', package: 'Standard', payment_method: 'โอนเงิน', amount: 'Baht 990.00', transaction_no: 'T000000000' },
    { seq: 5, date: '2021-09-15', package: 'Standard', payment_method: 'โอนเงิน', amount: 'Baht 990.00', transaction_no: 'T000000000' }
]

export default function CompanyDetail() {
    const { id } = useParams();

    const api = new ApiConection();
    const navigate = useNavigate();

    const [Register, setRegister] = useState({});
    const [company, setCompany] = useState(undefined);
    const [user, setUser] = useState(undefined);
    const [payee, setPayee] = useState(undefined);

    const [alert, setAlert] = useState('');
    const [loading, setLoading] = useState(true);

    const [Quonation, setQuontation] = useState({});
    const [loadingQt, setLoadingQt] = useState(false);

    const [pagination, setPagination] = useState({
        page: 1,
        size: 10,
        record_start: 0,
        record_end: 0,
        record_count: 0,
        page_count: 0
    })
    const [search, setSearch] = useState({
        page: 1,
        size: 10
    })
    const [QuonationList, setQuontationList] = useState([]);
    const [LoadingQtList, setLoadingQtList] = useState(false);

    const handleBreadcrumbClick = (e) => {
        navigate('/company');
    };

    const getRegister = async () => {
        setLoading(true);

        const response = await api.getData(`api/register/${id}`);

        if (response.status === true) {
            setRegister(response.data);
        }
        //console.log(response.data);
    }

    const getCompanyData = async () => {
        const response = await api.getData(`api/customerprofile/${Register.user_id}/register/${Register.register_number}/company`);
        //console.log(response);
        if (response.status === true) {
            setCompany(response.data);
        }
    }

    const getUserLoginData = async () => {
        const response = await api.getData(`api/customerprofile/${Register.user_id}/register/${Register.register_number}/user`)

        if (response.status === true) {
            setUser(response.data);
        }
    }

    const getPayeeData = async () => {
        const response = await api.getData(`api/customerprofile/${Register.user_id}/register/${Register.register_number}/payee`);
        //console.log(response);
        if (response.status === true) {
            setPayee(response.data);
        }
    }

    const getQuontationHistory = async () => {
        if (Register.register_number === undefined) return;

        let data = {
            search: {},
            pagination: {
                size: search.size,
                page: search.page,
                order_by: 'create_date',
                order_mode: 'desc'
            }
        }

        setLoadingQtList(true);

        const response_paging = await api.postData(`api/Quontation/register/${Register.register_number}/customer/${Register.user_id}/pagination`, data);

        if (response_paging.status === true) {
            handleSetPagination('record_start', response_paging.data.record_start);
            handleSetPagination('record_count', response_paging.data.record_count);
            handleSetPagination('page_count', response_paging.data.page_count);

            let record_end = response_paging.data.record_start + (search.size - 1);
            if (record_end > response_paging.data.record_count) {
                record_end = response_paging.data.record_count;
            }

            handleSetPagination('record_end', record_end);
        }

        const response_data = await api.postData(`api/Quontation/register/${Register.register_number}/customer/${Register.user_id}/result`, data);
        setQuontationList(response_data.data);
        //console.log(response_data.data);
        setLoadingQtList(false);
    }

    const handleSetPagination = (name, value) => {
        setPagination(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSetSearch = (name, value) => {
        setSearch(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSizeTableChange = (event) => {
        const { name, value } = event.target;
        handleSetSearch('page', 1);
        handleSetSearch('size', value);
    }
    const handlePagingChange = (page_no) => {
        handleSetSearch('page', page_no);
    }

    const setCompanyData = async (Childdata) => {
        let request = {
            "company_name": Childdata.company_name,
            "company_address": Childdata.company_address,
            "company_tel": Childdata.company_tel,
            "tax_id": Childdata.tax_id,
            "business_type_id": Childdata.business_type_id,
            "business_type_name": Childdata.business_type_name,
            "business_category_id": Childdata.business_category_id,
            "business_category_name": Childdata.business_category_name,
            "employee_count_id": Childdata.employee_count_id,
            "employee_count_name": Childdata.employee_count_name,
            "description": Childdata.description,
            "active_dcaas": Childdata.active_dcaas,
            "active": Childdata.active
        }

        const response = await api.putData(`api/customerprofile/${Register.user_id}/register/${Register.register_number}/company`, request);

        if (response.status === false) {
            setAlert(response.message);
            return false;
        }
        else {
            setAlert('');
            await getCompanyData();
            return true;
        }
    }

    const setUserData = async (Childdata) => {
        let request = {
            "first_name": Childdata.first_name,
            "last_name": Childdata.last_name,
            "tel": Childdata.tel,
        }

        //console.log(request);
        const response = await api.putData(`api/customerprofile/${Register.user_id}/register/${Register.register_number}/user`, request);
        //console.log(response);
        if (response.status === false) {
            setAlert(response.message);
        }
        else {
            setAlert('');
            getRegister();
        }
    }

    const setPayeeData = async (Childdata) => {
        let request = {
            "payee_name": Childdata.payee_name,
            "payee_address": Childdata.payee_address,
            "payee_tel": Childdata.payee_tel,
            "payee_tax_id": Childdata.payee_tax_id,
            "payee_branch": Childdata.payee_branch,
        }

        //console.log(request);
        const response = await api.putData(`api/customerprofile/${Register.user_id}/register/${Register.register_number}/payee`, request);
        //console.log(response);
        if (response.status === false) {
            setAlert(response.message);
        }
        else {
            setAlert('');
            getRegister();
        }
    }

    useEffect(() => {
        getRegister();
    }, [id])

    useEffect(() => {
        const initail = async () => {
            if (Register !== undefined && Register?.register_number !== undefined) {
                await getUserLoginData();
                await getCompanyData();
                await getPayeeData();
                await getQuontationHistory();

                setLoading(false);
            }
        }
        initail();
    }, [Register]);

    return (

        <Layout4Admin1 >
            {
                loading === false &&
                <div className={Css.Block_Transparent}>
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={handleBreadcrumbClick}>รายการลูกค้า</Breadcrumb.Item>
                        <Breadcrumb.Item active>{Register.company_name}</Breadcrumb.Item>
                    </Breadcrumb>
                    <div className='contrainer'>
                        <CustomerActions />
                        <ProfilePackageHistory page={search.page} size={search.size}
                            data={QuonationList}
                            paginate={pagination}
                            LoadingQtList={LoadingQtList}
                            handlePagingChange={handlePagingChange}
                            handleSizeTableChange={handleSizeTableChange} />
                        <ProfileCompany data={company} callSubmitParentData={setCompanyData} parentAlert={alert} />
                        <ProfilePackage data={Register.quontation} parentAlert={alert} />
                        <ProfileUser data={user} callSubmitParentData={setUserData} parentAlert={alert} />
                        <ProfilePayee data={payee} callSubmitParentData={setPayeeData} parentAlert={alert} />
                        <ProfileUseage data={Register} />
                    </div>
                </div>
            }
            {
                loading === true &&
                <div className={Css.Block_Transparent + ' placeholder-glow'}>
                    <h3 className="placeholder rounded col-12"></h3>
                    <div className='contrainer'>
                        <div className='mt-3 mb-3'>
                            <div className={`border rounded p-4 bg-white shadow w-100`}>
                                <span className="placeholder bg-secondary rounded col-7" ></span>
                                <span className="placeholder bg-secondary rounded col-5" ></span>
                                <span className="placeholder bg-secondary rounded col-8" ></span>
                                <span className="placeholder bg-secondary rounded col-4" ></span>
                                <span className="placeholder bg-secondary rounded col-5" ></span>
                                <span className="placeholder bg-secondary rounded col-7" ></span>
                                <span className="placeholder bg-secondary rounded col-3" ></span>
                                <span className="placeholder bg-secondary rounded col-2" ></span>
                                <span className="placeholder bg-secondary rounded col-8" ></span>
                            </div>
                        </div>

                    </div>
                </div>
            }

        </Layout4Admin1>
    )
}